import styled, { withTheme } from 'styled-components';

const AccountFormOuterFragment = styled.div`
    margin:60px 0 50px 0;
`;

export default withTheme(AccountFormOuterFragment);
